/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface MgtUpdateStoreTapPayCardReq {
  /** TapPay prime */
  prime: string;

  /** 持卡人電話 */
  phoneNumber: string;

  /** 持卡人姓名 */
  name: string;

  /** 持卡人Email */
  email: string;

  /** 持卡人郵遞區號 */
  zipCode?: string;

  /** 持卡人地址 */
  address?: string;

  /** 持卡人身分證號 */
  nationalId?: string;
}

/**
 * Logo圖片
 */
export interface FileDto {
  /**
   * id of File
   * @format int32
   */
  id: number;

  /** 檔案名稱 */
  name: string;

  /** 檔案類型 */
  contentType: string;

  /** 檔案所屬物件類型 */
  relateType?:
    | "GROUP"
    | "STORE"
    | "USER"
    | "ORDER"
    | "RESOURCE"
    | "STORE_REPORT"
    | "CMS_CONSUMER_IMPORT"
    | "SIGNATURE"
    | "ORDER_CHECKOUT"
    | "BILL";

  /**
   * 檔案所屬物件編號
   * @format int32
   */
  relateTypeId?: number;

  /** 檔案URL */
  url?: string;
}

/**
 * 下次付款方案
 */
export interface MgtPlanStoreDto {
  /**
   * id
   * @format int32
   */
  id: number;

  /** 名稱 */
  name: string;

  /**
   * 價格(基礎價格)
   * @format int32
   */
  price: number;

  /**
   * 價格(上限)
   * @format int32
   */
  priceLimit: number;

  /**
   * 免費設計師數
   * @format int32
   */
  freeResourceAmount: number;

  /**
   * 額外每位設計師費用
   * @format int32
   */
  pricePerExtraResource: number;

  /** 繳費週期(staticOptions.planPaymentPeriod) */
  period: "MONTH" | "YEAR";

  /** 狀態（staticOptions.onOffStatus） */
  status: "ON" | "OFF";
}

export interface MgtStoreDetailDto {
  /**
   * id
   * @format int32
   */
  id: number;

  /** hashId */
  hashId: string;

  /**
   * 建立時間
   * @format date-time
   */
  createdAt: string;

  /** 名稱 */
  name: string;

  /** 狀態（staticOptions.storeStatus） */
  status: "ON" | "OFF" | "DRAFT" | "PAY_EXPIRE";

  /**
   * 下次付款時間
   * @format date-time
   */
  nextPaymentDateTime?: string;

  /**
   * 當前Plan到期日
   * @format date-time
   */
  planExpireDateTime?: string;

  /** 下次付款方案 */
  plan?: MgtPlanStoreDto;

  /** 下次付款方案 */
  nextPlan?: MgtPlanStoreDto;

  /** TapPay信用卡資訊 */
  tapPayCardInfo?: MgtTapPayCardInfoInStoreDto;

  /** 最近一次付款紀錄 */
  lastPaymentHistory?: MgtStorePaymentHistoryDto;

  /**
   * 儲值點數
   * @format double
   */
  point: number;

  /**
   * 試用期到期日
   * @format date-time
   */
  lastTrialDate?: string;

  /** Logo圖片 */
  logoPhotoFile?: FileDto;

  /** 邀請碼 */
  inviteCode?: string;

  /** 是否綁定過信用卡 */
  bindCreditCard: boolean;
}

/**
 * 最近一次付款紀錄
 */
export interface MgtStorePaymentHistoryDto {
  /**
   * id
   * @format int32
   */
  id: number;

  /**
   * 建立時間
   * @format date-time
   */
  createdAt: string;

  /** 付款明細顯示項目 */
  item?: string;

  /** 說明 */
  description?: string;

  /** 付款類型 */
  historyType: "PLAN" | "SMS_BILLING" | "BILL" | "DEPOSIT" | "UPDATE_PLAN";

  /**
   * 實付金額
   * @format double
   */
  amount?: number;

  /** 付款狀態(staticOptions.storePaymentStatus) */
  paymentStatus: "OK" | "TX_FAIL" | "NO_CARD" | "NO_PLAN";

  /** TapPay信用卡資訊 */
  tapPayCardInfo?: MgtTapPayCardInfoInStoreDto;

  /** 支付供應商交易編號 */
  paymentGatewayTxId?: string;

  /** 發票號碼 */
  invoiceNo?: string;
}

/**
 * TapPay信用卡資訊
 */
export interface MgtTapPayCardInfoInStoreDto {
  /**
   * id
   * @format int32
   */
  id: number;

  /**
   * 建立時間
   * @format date-time
   */
  createdAt: string;

  /** 卡片前六碼 */
  binCode?: string;

  /** 卡片後四碼 */
  lastFour?: string;

  /** 發卡銀行 */
  issuer?: string;

  /**
   * 卡片類別
   * @format int32
   */
  funding?: number;

  /**
   * 卡片種類
   * @format int32
   */
  type?: number;

  /** 卡片等級 */
  level?: string;

  /** 發卡行國家 */
  country?: string;

  /** 發卡行國家碼 */
  countryCode?: string;
}

export interface MgtUpdateStoreResourceTargetAndBonusesReq {
  type: "ORDER" | "DEPOSIT_POINT" | "VOUCHER" | "PRODUCT";

  /** @format double */
  targetPerformance: number;

  /** @format double */
  targetBonus: number;
}

export interface MgtStoreResourcePerformanceTargetAndBonusesDto {
  /** @format int32 */
  resourceId: number;
  type: "ORDER" | "DEPOSIT_POINT" | "VOUCHER" | "PRODUCT";

  /** @format double */
  targetPerformance: number;

  /** @format double */
  targetBonus: number;
}

export interface MgtUpdateStoreResourceCommissionRateReq {
  type: "ORDER" | "DEPOSIT_POINT" | "VOUCHER" | "PRODUCT";

  /** @format double */
  specificCommissionRate: number;

  /** @format double */
  unspecificCommissionRate: number;
}

export interface MgtStoreResourceCommissionRateDto {
  /** @format int32 */
  resourceId: number;
  type: "ORDER" | "DEPOSIT_POINT" | "VOUCHER" | "PRODUCT";

  /** @format double */
  specificCommissionRate: number;

  /** @format double */
  unspecificCommissionRate: number;
}

export interface MgtStorePlanDowngradeRecordDto {
  otherReason?: string;
  reason: (
    | "PRODUCT_UNMET_EXPECTATIONS"
    | "UNNEEDED_FEATURES"
    | "INSUFFICIENT_TRAINING"
    | "COST_RELATED_REASONS"
    | "UNSTABLE_SYSTEM"
    | "USING_OTHER_PRODUCTS"
    | "OTHER"
  )[];
}

export interface MgtUpdateStorePlanInvoiceDetailReq {
  /** 統一編號 */
  vatNo: string;

  /** 公司抬頭 */
  invoiceHeading: string;

  /** 帳務Email */
  invoiceEmail: string;
}

export interface MgtUpdateStorePlanTapPayCardReq {
  /** TapPay prime */
  prime: string;

  /** 持卡人電話 */
  phoneNumber: string;

  /** 持卡人姓名 */
  name: string;

  /** 持卡人Email */
  email: string;

  /** 持卡人郵遞區號 */
  zipCode?: string;

  /** 持卡人地址 */
  address?: string;

  /** 持卡人身分證號 */
  nationalId?: string;
}

export interface MgtUpdateStorePlanWithPaymentReq {
  invoiceDetail?: MgtUpdateStorePlanInvoiceDetailReq;
  tapPayCard?: MgtUpdateStorePlanTapPayCardReq;
  downgradedReason?: MgtStorePlanDowngradeRecordDto;

  /** 需要重新綁卡並且馬上付款 */
  needToRebindCard?: boolean;
}

export interface MgtUpdateStorePlanDto {
  /**
   * id
   * @format int32
   */
  id: number;

  /**
   * 建立時間
   * @format date-time
   */
  createdAt: string;

  /** 名稱 */
  name: string;

  /** 狀態（staticOptions.storeStatus） */
  status: "ON" | "OFF" | "DRAFT" | "PAY_EXPIRE";

  /**
   * 下次付款時間
   * @format date-time
   */
  nextPaymentDateTime?: string;

  /**
   * 當前Plan到期日
   * @format date-time
   */
  planExpireDateTime?: string;

  /** 下次付款方案 */
  plan?: MgtPlanStoreDto;

  /** 下次付款方案 */
  nextPlan?: MgtPlanStoreDto;

  /**
   * 試用期到期日
   * @format date-time
   */
  lastTrialDate?: string;
  downgradedReason?: MgtStorePlanDowngradeRecordDto;
}

export interface MgtStoreInvoiceDetailReq {
  /** 統一編號 */
  vatNo: string;

  /** 公司抬頭 */
  invoiceHeading: string;

  /** 帳務Email */
  invoiceEmail: string;
}

export interface MgtStoreInvoiceDetailDto {
  /**
   * id
   * @format int32
   */
  id: number;

  /** 統一編號 */
  vatNo: string;

  /** 公司抬頭 */
  invoiceHeading: string;

  /** 帳務Email */
  invoiceEmail: string;
}

export interface MgtUpdateGroupUserReq {
  /** 角色 */
  role: "OWNER" | "USER";

  /** 管理分店編號 */
  storeIds: number[];

  /** 名稱  */
  name: string;

  /** 電話國碼 */
  phoneCountryCode: string;

  /** 電話號碼 */
  phone: string;

  /** Email */
  email: string;
}

export interface MgtGroupUserDetailDto {
  /** Email */
  email: string;

  /** 名稱  */
  name: string;

  /** 電話號碼 */
  phone: string;

  /** 電話國碼 */
  phoneCountryCode: string;

  /** @format int32 */
  id: number;

  /** 角色 */
  role: "OWNER" | "USER";

  /** 管理分店 */
  stores: MgtStoreDto[];
}

/**
 * 管理分店
 */
export interface MgtStoreDto {
  /**
   * id
   * @format int32
   */
  id: number;

  /** hashId */
  hashId: string;

  /**
   * 建立時間
   * @format date-time
   */
  createdAt: string;

  /** 名稱 */
  name: string;

  /** 狀態（staticOptions.storeStatus） */
  status: "ON" | "OFF" | "DRAFT" | "PAY_EXPIRE";

  /**
   * 下次付款時間
   * @format date-time
   */
  nextPaymentDateTime?: string;

  /**
   * 當前Plan到期日
   * @format date-time
   */
  planExpireDateTime?: string;

  /** 下次付款方案 */
  plan?: MgtPlanStoreDto;

  /** 下次付款方案 */
  nextPlan?: MgtPlanStoreDto;

  /** TapPay信用卡資訊 */
  tapPayCardInfo?: MgtTapPayCardInfoInStoreDto;

  /** 最近一次付款紀錄 */
  lastPaymentHistory?: MgtStorePaymentHistoryDto;

  /**
   * 儲值點數
   * @format double
   */
  point: number;

  /**
   * 試用期到期日
   * @format date-time
   */
  lastTrialDate?: string;

  /**
   * 預估扣款金額
   * @format double
   */
  nextEstimatedCharge?: number;

  /** Logo圖片 */
  logoPhotoFile?: FileDto;

  /** 邀請碼 */
  inviteCode?: string;

  /**
   * 已綁定的金流家數
   * @format int32
   */
  boundPaymentGatewayCnt?: number;
}

export interface MgtSearchStorePaymentHistoryReq {
  paymentTypeList?: (
    | "PLAN"
    | "SMS_BILLING"
    | "BILL"
    | "DEPOSIT"
    | "UPDATE_PLAN"
  )[];

  /** 分頁 */
  paging: PagingRequest;

  /** 排序 */
  sorts?: SortField[];
}

/**
 * 分頁
 */
export interface PagingRequest {
  /**
   * 頁次（從1開始）
   * @format int32
   */
  page: number;

  /**
   * 每頁數量
   * @format int32
   */
  pageSize: number;
}

/**
 * 排序
 */
export interface SortField {
  /** 排序方式 */
  sort?: "ASC" | "DESC";

  /** 排序欄位 */
  field?: string;
}

export interface PageDtoMgtStorePaymentHistoryDto {
  /** @format int32 */
  atPage: number;

  /** @format int32 */
  totalPages: number;
  items: MgtStorePaymentHistoryDto[];

  /** @format int64 */
  totalCount: number;
}

export interface PagingAndSortingRequest {
  /** 分頁 */
  paging: PagingRequest;

  /** 排序 */
  sorts?: SortField[];
}

export interface MgtStorePointHistoryDto {
  /**
   * id
   * @format int32
   */
  id: number;

  /**
   * 建立時間
   * @format date-time
   */
  createdAt: string;

  /**
   * 點數
   * @format double
   */
  point: number;

  /** 異動類型 (staticOptions.storePointHistoryType) */
  historyType:
    | "SMS_BILLING"
    | "PLAN"
    | "Bill"
    | "DEPOSIT"
    | "CMS"
    | "UPDATE_PLAN"
    | "INVITATION_REWARD";

  /**
   * 剩餘點數
   * @format double
   */
  afterPoint: number;

  /** 描述 */
  description: string;

  /** 最近一次付款紀錄 */
  paymentHistory?: MgtStorePaymentHistoryDto;
}

export interface PageDtoMgtStorePointHistoryDto {
  /** @format int32 */
  atPage: number;

  /** @format int32 */
  totalPages: number;
  items: MgtStorePointHistoryDto[];

  /** @format int64 */
  totalCount: number;
}

export interface MgtBindStorePaymentIntegrationReq {
  userConfig: Record<string, string>;
}

export interface MgtBindStorePaymentGatewayFieldDto {
  /** 金流串接欄位名稱 */
  label: string;

  /** 金流串接欄位屬性，綁定時會將此屬性的值帶入 userConfig */
  prop: string;

  /** 金流串接欄位名稱-必填 */
  required: boolean;
}

export interface MgtStorePaymentIntegrationDto {
  gateway: "INSTO" | "LINE_PAY";
  gatewayType: "CREDIT_CARD" | "OTHER";
  bindStatus: "ON" | "OFF";
  userConfigFields: MgtBindStorePaymentGatewayFieldDto[];
}

export interface MgtDepositStorePointReq {
  /**
   * 點數
   * @format double
   */
  point: number;
}

export interface MgtCreateGroupUserReq {
  /** 角色 */
  role: "OWNER" | "USER";

  /** 管理分店編號 */
  storeIds: number[];

  /** 名稱  */
  name: string;

  /** 電話國碼 */
  phoneCountryCode: string;

  /** 電話號碼 */
  phone: string;

  /** Email */
  email: string;
}

export interface MgtSearchGroupUserDto {
  /** Email */
  email: string;

  /** 名稱  */
  name: string;

  /** 電話號碼 */
  phone: string;

  /** 電話國碼 */
  phoneCountryCode: string;

  /** @format int32 */
  id: number;

  /** 角色 */
  role: "OWNER" | "USER";
}

export interface MgtSwitchGroupReq {
  /**
   * 切換Group Id，null則視同登出Group
   * @format int32
   */
  groupId?: number;
}

/**
 * Group Info
 */
export interface MgtGroupDto {
  /**
   * id
   * @format int32
   */
  id: number;

  /**
   * 建立時間
   * @format date-time
   */
  createdAt: string;

  /** 名稱 */
  name: string;

  /**
   * Logo圖片Id
   * @format int32
   */
  logoPhotoFileId?: number;

  /**
   * 主圖片Id
   * @format int32
   */
  mainPhotoFileId?: number;

  /** Logo圖片 */
  logoPhotoFile?: FileDto;
}

export interface MgtSwitchGroupRes {
  /** Group Token */
  token: string;

  /** Group Info */
  group?: MgtGroupDto;
}

export interface MgtSearchDashboardPeroidSummaryReq {
  /** 查詢區間 */
  time: SearchDateTimeRange;
}

/**
 * 查詢區間
 */
export interface SearchDateTimeRange {
  /**
   * 開始時間
   * @format date-time
   */
  from?: string;

  /**
   * 結束時間（不包含）
   * @format date-time
   */
  until?: string;
}

/**
 * Resources
 */
export interface MgtDashboardResourceInStorePeroidSummaryDto {
  /**
   * 訂單數
   * @format int32
   */
  totalOrderCount: number;

  /**
   * 消費金額(結帳金額)
   * @format double
   */
  totalCheckoutPrice: number;

  /**
   * 折扣金額
   * @format double
   */
  totalDiscountPrice: number;

  /** Resource */
  resource: MgtResourceDto;
}

export interface MgtDashboardStorePeroidSummaryDto {
  /**
   * 訂單數
   * @format int32
   */
  totalOrderCount: number;

  /**
   * 消費金額(結帳金額)
   * @format double
   */
  totalCheckoutPrice: number;

  /**
   * 平均客單價
   * @format double
   */
  avgCheckoutPrice: number;

  /**
   * 儲值金收入
   * @format double
   */
  totalCheckoutPriceByDepositPoint: number;

  /** Resources */
  resources: MgtDashboardResourceInStorePeroidSummaryDto[];
}

/**
 * Resource
 */
export interface MgtResourceDto {
  /**
   * id
   * @format int32
   */
  id: number;

  /** 設計師名稱 */
  name: string;
}

export interface MgtDownloadGroupStoreSummaryReportReq {
  /** 查詢區間 */
  time: SearchDateTimeRange;

  /** 報表類型 */
  reportType:
    | "ORDER"
    | "DEPOSIT_POINT"
    | "BONUS_POINT"
    | "VOUCHER"
    | "BILL"
    | "ITEM_SUMMARY"
    | "PERFORMANCE_SUMMARY"
    | "PRODUCT_USAGE";
}

export interface MgtOrderDailyCountDto {
  /** @format date */
  date: string;

  /** @format int32 */
  cntCanceled: number;

  /** @format int32 */
  cntNoShow: number;

  /** @format int32 */
  cntCheckedIn: number;
}

/**
 * 主控台-分店-薪資計算-比例抽成制
 */
export interface MgtStoreResourceSalaryAnalyzeCommissionDto {
  /** Resource */
  resource: MgtResourceDto;
  salaryOrder: MgtStoreResourceSalaryAnalyzeInCommissionByBillTypeDto;
  salaryProduct: MgtStoreResourceSalaryAnalyzeInCommissionByBillTypeDto;
  salaryVoucher: MgtStoreResourceSalaryAnalyzeInCommissionByBillTypeDto;
  salaryDeposit: MgtStoreResourceSalaryAnalyzeInCommissionByBillTypeDto;
}

export interface MgtStoreResourceSalaryAnalyzeInCommissionByBillTypeDto {
  billType: "ORDER" | "DEPOSIT_POINT" | "VOUCHER" | "PRODUCT";

  /**
   * 指定抽成率
   * @format double
   */
  salarySpecifyRate: number;

  /**
   * 指定抽成金額
   * @format double
   */
  salarySpecifyAmountWithRate: number;

  /**
   * 不指定抽成率
   * @format double
   */
  salaryUnSpecifyRate: number;

  /**
   * 不指定抽成金額
   * @format double
   */
  salaryUnSpecifyAmountWithRate: number;

  /**
   * 達標獎金
   * @format double
   */
  bonus: number;

  /**
   * 總額
   * @format double
   */
  sum: number;
}

/**
 * 主控台-分店-請領分析
 */
export interface MgtStoreResourceProductAcquisitionAnalyzeDto {
  /** Resource */
  resource: MgtResourceDto;
  productItem: MgtStoreResourceProductAcquisitionItemAnalyzeDto[];

  /** @format int32 */
  sum: number;
}

/**
 * 主控台-分店-請領分析-商品項目
 */
export interface MgtStoreResourceProductAcquisitionItemAnalyzeDto {
  productName: string;

  /**
   * 數量
   * @format int32
   */
  productCount: number;

  /**
   * 金額
   * @format int32
   */
  productAmount: number;
}

/**
 * 項目排行
 */
export interface MgtStoreBillItemRankDto {
  /** 項目 */
  item: string;

  /**
   * 次數
   * @format int32
   */
  billTimes: number;

  /**
   * 金額
   * @format double
   */
  totalPrice: number;
}

/**
 * 各支付方式統計
 */
export interface MgtStoreBillPaymentTotalPriceDto {
  /** 支付類型 */
  paymentType: string;

  /**
   * 佔比
   * @format double
   */
  proportion: number;

  /** @format double */
  totalPrice: number;
}

/**
 * 來源分析-性別分析-其他
 */
export interface MgtStoreResourceBillAnalyzeCountAndPriceDto {
  /** @format int32 */
  cnt: number;

  /** @format double */
  price: number;
}

export interface MgtStoreResourcePerformanceAnalyzeByBillTypeDto {
  billType: "ORDER" | "DEPOSIT_POINT" | "VOUCHER" | "PRODUCT";

  /**
   * 指定業績
   * @format double
   */
  performanceSpecify: number;

  /**
   * 不指定業績
   * @format double
   */
  performanceUnSpecify: number;

  /** 來源分析-性別分析-其他 */
  specifyOrders: MgtStoreResourceBillAnalyzeCountAndPriceDto;

  /** 來源分析-性別分析-其他 */
  unSpecifyOrders: MgtStoreResourceBillAnalyzeCountAndPriceDto;

  /** 來源分析-性別分析-其他 */
  firstTimeConsumerOrders: MgtStoreResourceBillAnalyzeCountAndPriceDto;

  /** 來源分析-性別分析-其他 */
  secondTimeConsumerOrders: MgtStoreResourceBillAnalyzeCountAndPriceDto;

  /** 來源分析-性別分析-其他 */
  oldConsumerOrders: MgtStoreResourceBillAnalyzeCountAndPriceDto;

  /** 來源分析-性別分析-其他 */
  genderMaleConsumerOrders: MgtStoreResourceBillAnalyzeCountAndPriceDto;

  /** 來源分析-性別分析-其他 */
  genderFemaleConsumerOrders: MgtStoreResourceBillAnalyzeCountAndPriceDto;

  /** 來源分析-性別分析-其他 */
  genderOtherConsumerOrders: MgtStoreResourceBillAnalyzeCountAndPriceDto;

  /** 項目排行 */
  itemRanks: MgtStoreBillItemRankDto[];

  /** 各支付方式統計 */
  billPrices: MgtStoreBillPaymentTotalPriceDto[];
}

/**
 * 主控台-分店-業績分析
 */
export interface MgtStoreResourcePerformanceAnalyzeDto {
  /** Resource */
  resource: MgtResourceDto;
  performanceOrder: MgtStoreResourcePerformanceAnalyzeByBillTypeDto;
  performanceProduct: MgtStoreResourcePerformanceAnalyzeByBillTypeDto;
  performanceVoucher: MgtStoreResourcePerformanceAnalyzeByBillTypeDto;
  performanceDeposit: MgtStoreResourcePerformanceAnalyzeByBillTypeDto;
}

export interface MgtStoreBillAnalyzeDto {
  /** 總覽-支付方式 */
  billPricesAll: MgtStoreBillPaymentTotalPriceDto[];

  /** 總覽-服務結帳-支付方式 */
  billPricesOrder: MgtStoreBillPaymentTotalPriceDto[];

  /** 總覽-服務結帳-項目排行 */
  billItemRanksOrder: MgtStoreBillItemRankDto[];

  /** 總覽-商品結帳-支付方式 */
  billPricesProduct: MgtStoreBillPaymentTotalPriceDto[];

  /** 總覽-商品結帳-項目排行 */
  billItemRanksProduct: MgtStoreBillItemRankDto[];

  /** 總覽-儲值金結帳-支付方式 */
  billPricesDeposit: MgtStoreBillPaymentTotalPriceDto[];

  /** 總覽-票券結帳-支付方式 */
  billPricesVoucher: MgtStoreBillPaymentTotalPriceDto[];

  /** 總覽-票券結帳-項目排行 */
  billItemRanksVoucher: MgtStoreBillItemRankDto[];
}

export interface MgtDashboardGroupPeroidSummaryDto {
  /**
   * 會員數
   * @format int32
   */
  totalMemberCount: number;

  /**
   * 訂單數
   * @format int32
   */
  totalOrderCount: number;

  /**
   * 消費金額(結帳金額)
   * @format double
   */
  totalCheckoutPrice: number;
}

export interface MgtGroupDailyOrderCustomerVisitDto {
  /** @format date */
  date: string;

  /**
   * 新客數
   * @format int32
   */
  firstVisitCnt: number;

  /**
   * 2次客數
   * @format int32
   */
  secondVisitCnt: number;

  /**
   * 3次+客數
   * @format int32
   */
  thirdVisitCnt: number;
}

export interface MgtGroupOrderAnalyzeDto {
  /** @format int32 */
  totalOrderCount: number;

  /**
   * 出席數
   * @format int32
   */
  checkedInCount: number;

  /**
   * 爽約數
   * @format int32
   */
  noShowCount: number;

  /**
   * 取消數
   * @format int32
   */
  cancelCount: number;

  /**
   * 熟客數
   * @format int32
   */
  regularConsumerCount: number;

  /**
   * 指定數
   * @format int32
   */
  specifyCount: number;
}

export interface MgtClerkDto {
  /**
   * id
   * @format int32
   */
  id: number;

  /** 名稱 */
  name: string;
}

export interface MgtConsumerDto {
  /** @format int32 */
  id: number;

  /** 名稱 */
  name?: string;
}

export interface MgtConsumerGroupDepositHistoryDto {
  /**
   * 異動儲值點數
   * @format double
   */
  modifyDepositPoint: number;

  /**
   * 異動後儲值點數
   * @format double
   */
  resultDepositPoint: number;

  /**
   * 紀錄時間
   * @format date-time
   */
  createdAt: string;

  /** 點數異動類型 */
  modifyType:
    | "ORDER_CHECKOUT"
    | "ORDER_CHECKOUT_MODIFY"
    | "PAD_MODIFY"
    | "CMS_UPLOAD"
    | "BILL_PAYMENT"
    | "BILL_PAYMENT_ROLLBACK"
    | "BILL_PURCHASE"
    | "BILL_PURCHASE_ROLLBACK"
    | "ORDER_PREPAY"
    | "MEMBER_TRANSFER";

  /**
   * 購買金額
   * @format double
   */
  purchasePrice?: number;

  /**
   * 帳單編號
   * @format int32
   */
  billId?: number;

  /** 備註 */
  remark?: string;
  clerk?: MgtClerkDto;

  /** 管理分店 */
  store?: MgtStoreDto;
  consumer?: MgtConsumerDto;
}

export interface PageDtoMgtConsumerGroupDepositHistoryDto {
  /** @format int32 */
  atPage: number;

  /** @format int32 */
  totalPages: number;
  items: MgtConsumerGroupDepositHistoryDto[];

  /** @format int64 */
  totalCount: number;
}

export interface MgtConsumerGroupBonusHistoryDto {
  /**
   * 異動紅利點數
   * @format double
   */
  modifyBonusPoint: number;

  /**
   * 異動後紅利點數
   * @format double
   */
  resultBonusPoint: number;

  /**
   * 紀錄時間
   * @format date-time
   */
  createdAt: string;

  /** 點數異動類型(staticOptions.consumerGroupBonusHistoryModifyType) */
  modifyType:
    | "ORDER"
    | "PAD_MODIFY"
    | "CMS_UPLOAD"
    | "BILL"
    | "BILL_ROLLBACK"
    | "VOUCHER_EXCHANGE"
    | "MEMBER_TRANSFER";

  /**
   * 帳單編號
   * @format int32
   */
  billId?: number;

  /** 備註 */
  remark?: string;
  consumer?: MgtConsumerDto;
  clerk?: MgtClerkDto;

  /** 管理分店 */
  store?: MgtStoreDto;
}

export interface PageDtoMgtConsumerGroupBonusHistoryDto {
  /** @format int32 */
  atPage: number;

  /** @format int32 */
  totalPages: number;
  items: MgtConsumerGroupBonusHistoryDto[];

  /** @format int64 */
  totalCount: number;
}

export interface MgtUpdateStorePlanInfoDto {
  /**
   * 新方案開始日
   * @format date-time
   */
  newPlanStartDate?: string;

  /**
   * 新方案結束日
   * @format date-time
   */
  newPlanEndDate?: string;

  /** 新選擇方案 */
  lastPlan?: MgtUpdateStorePlanPlanDto;

  /** 新選擇方案 */
  newPlan?: MgtUpdateStorePlanPlanDto;

  /**
   * 設計師人數
   * @format int32
   */
  lastResourceCount?: number;

  /**
   * 上期簡訊費用
   * @format int32
   */
  lastSmsAmount?: number;

  /**
   * 上期方案退款
   * @format int32
   */
  lastPlanRefundAmount?: number;

  /**
   * 應付金額
   * @format int32
   */
  payableAmount?: number;

  /**
   * 夯幣折抵
   * @format int32
   */
  pointUse?: number;

  /**
   * 新方案總費用
   * @format double
   */
  newPlanTotal?: number;

  /**
   * 總計
   * @format int32
   */
  totalAmount?: number;

  /**
   * 夯幣退款
   * @format int32
   */
  pointRefundAmount?: number;

  /** 信用卡 */
  cardInfo?: MgtUpdateStorePlanTapPayCardDto;

  /**
   * 試用期到期日 (試用期間提供)
   * @format date-time
   */
  lastTrialDate?: string;

  /**
   * 預計試用期到期日 (未進入試用期提供)
   * @format date-time
   */
  expectLastTrialDate?: string;
}

/**
 * 新選擇方案
 */
export interface MgtUpdateStorePlanPlanDto {
  /** 名稱 */
  name: string;

  /**
   * 價格(基礎價格)
   * @format int32
   */
  price: number;
}

/**
 * 信用卡
 */
export interface MgtUpdateStorePlanTapPayCardDto {
  /** 卡片後四碼 */
  lastFour?: string;

  /** 發卡銀行 */
  issuer?: string;
}

export interface MgtNextEstimatedChargeInfoDto {
  /**
   * 新方案開始日
   * @format date-time
   */
  newPlanStartDate?: string;

  /**
   * 新方案結束日
   * @format date-time
   */
  newPlanEndDate?: string;

  /** 新選擇方案 */
  newPlan?: MgtUpdateStorePlanPlanDto;

  /**
   * 設計師人數
   * @format int32
   */
  lastResourceCount?: number;

  /**
   * 上期簡訊費用
   * @format int32
   */
  lastSmsAmount?: number;

  /**
   * 新方案總費用
   * @format double
   */
  newPlanTotal?: number;

  /**
   * 總計
   * @format int32
   */
  totalAmount?: number;
}

export interface MgtInvitedStoreDto {
  /**
   * 建立時間
   * @format date-time
   */
  createdAt: string;

  /** 名稱 */
  name: string;

  /** Group */
  groupName: string;

  /** 下次付款方案 */
  plan?: MgtPlanStoreDto;
}

export interface MgtStoreInvitationHistoryDto {
  /** 邀請獎勵狀態 */
  creditStatus: "NA" | "CREDIT_EARNED";
  store: MgtInvitedStoreDto;
}

export interface MgtStoreInvitationInfoDto {
  inviteCode: string;

  /**
   * 累積獲得額度(月)
   * @format int32
   */
  earnCredit: number;
  invitedStores?: MgtStoreInvitationHistoryDto[];
}

export interface MgtPlanDetailDto {
  /**
   * id
   * @format int32
   */
  id: number;

  /** 名稱 */
  name: string;

  /**
   * 訂單量上限
   * @format int32
   */
  orderLimit: number;

  /**
   * 價格(基礎價格)
   * @format int32
   */
  price: number;

  /**
   * 價格(上限)
   * @format int32
   */
  priceLimit: number;

  /**
   * 免費設計師數
   * @format int32
   */
  freeResourceAmount: number;

  /**
   * 額外每位設計師費用
   * @format int32
   */
  pricePerExtraResource: number;

  /** 繳費週期(staticOptions.planPaymentPeriod) */
  period: "MONTH" | "YEAR";

  /** 狀態（staticOptions.onOffStatus） */
  status: "ON" | "OFF";
}

export interface MgtGroupUserDto {
  /** Email */
  email: string;

  /** 名稱  */
  name: string;

  /** 角色 */
  role: "OWNER" | "USER";

  /** Group Info */
  group: MgtGroupDto;
}

export interface MgtDashboardSummaryDto {
  /**
   * 更新時間
   * @format date-time
   */
  updatedAt: string;

  /**
   * 累積會員數
   * @format int32
   */
  totalMemberCount: number;

  /**
   * 累積訂單數
   * @format int32
   */
  totalOrderCount: number;

  /**
   * 累積總消費金額
   * @format double
   */
  totalCheckoutPrice: number;

  /**
   * 累積平均客單價
   * @format double
   */
  avgCheckoutPrice: number;

  /**
   * 儲值金
   * @format double
   */
  totalDepositPoint: number;
}

/**
 * 預約指定/熟客分析
 */
export interface MgtStoreResourceOrderAnalyzeFromLastMonthDto {
  /** Resource */
  resource?: MgtResourceDto;

  /**
   * 本月總預約數
   * @format int32
   */
  thisMonthTotalOrderCnt: number;

  /**
   * 本月舊客數
   * @format int32
   */
  thisMonthOldConsumerOrderCnt: number;

  /**
   * 本月指定預約數
   * @format int32
   */
  thisMonthSpecifyOrderCnt: number;

  /**
   * 上月總預約數
   * @format int32
   */
  lastMonthTotalOrderCnt: number;

  /**
   * 上月舊客數
   * @format int32
   */
  lastMonthOldConsumerOrderCnt: number;

  /**
   * 上月指定預約數
   * @format int32
   */
  lastMonthSpecifyOrderCnt: number;
}

/**
 * 會員背景分析/年齡層-性別
 */
export interface MgtConsumerBackgroundAnalyzeDto {
  /** 年齡層 */
  consumerAgeLevel:
    | "BELOW16"
    | "BELOW20"
    | "BELOW25"
    | "BELOW30"
    | "BELOW35"
    | "BELOW40"
    | "BELOW45"
    | "BELOW50"
    | "BELOW55"
    | "BELOW60"
    | "BELOW65"
    | "BELOW70"
    | "OVER50"
    | "OVER70"
    | "UNKNOWN";

  /** 性別 */
  gender: "MALE" | "FEMALE" | "OTHER";

  /**
   * 顧客數
   * @format int32
   */
  cnt: number;
}

export interface MgtGroupVoucherAnalyzeDto {
  /**
   * 票券編號
   * @format int32
   */
  voucherTemplateId: number;

  /** 票券名稱 */
  voucherTemplateName: string;

  /**
   * 發出數量
   * @format int32
   */
  sentCount: number;

  /**
   * 過期數量
   * @format int32
   */
  expiredCount: number;

  /**
   * 核銷數量
   * @format int32
   */
  usedCount: number;

  /**
   * 剩餘數量
   * @format int32
   */
  availableCount: number;
}

export interface MgtGroupDepositPointAnalyzeDto {
  /**
   * 發出儲值金
   * @format double
   */
  sentDepositPoint: number;

  /**
   * 剩餘儲值金
   * @format double
   */
  remainDepositPoint: number;
}

export interface ApiErrorResponse {
  code: string;
  name: string;
  messages: string[];
}

/**
 * API Version
 * @example 20220901
 */
export type ApiVersion = string;

import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  ResponseType,
} from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL:
        axiosConfig.baseURL ||
        "http://hunger-sit-api.ap-northeast-1.elasticbeanstalk.com",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.instance.defaults.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      formData.append(
        key,
        property instanceof Blob
          ? property
          : typeof property === "object" && property !== null
          ? JSON.stringify(property)
          : `${property}`
      );
      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = (format && this.format) || void 0;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      requestParams.headers.common = { Accept: "*/*" };
      requestParams.headers.post = {};
      requestParams.headers.put = {};

      body = this.createFormData(body as Record<string, unknown>);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData
          ? { "Content-Type": type }
          : {}),
        ...(requestParams.headers || {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Hunger API - 商家後台
 * @version 1.0
 * @baseUrl http://hunger-sit-api.ap-northeast-1.elasticbeanstalk.com
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags MgtStoreApi
     * @name UpdateStoreTapPayCard
     * @summary updateStoreTapPayCard 透過TapPay驗證信用卡並儲存
     * @request PUT:/api/v3/mgt/store/{storeId}/tapPayCard
     * @secure
     */
    updateStoreTapPayCard: (
      storeId: number,
      data: MgtUpdateStoreTapPayCardReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtStoreDetailDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/tapPayCard`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreApi
     * @name RemoveStoreTapPayCard
     * @summary removeStoreTapPayCard 解除商家tap pay 信用卡綁定
     * @request DELETE:/api/v3/mgt/store/{storeId}/tapPayCard
     * @secure
     */
    removeStoreTapPayCard: (storeId: number, params: RequestParams = {}) =>
      this.request<
        MgtStoreDetailDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/tapPayCard`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreResourcePerformanceConfigApi
     * @name GetTargetAndBonusesConfig
     * @summary getTargetAndBonusesConfig 查詢業績目標與獎金設定
     * @request GET:/api/v3/mgt/store/{storeId}/resource/{resourceId}/performance/targetAndBonusesConfig
     * @secure
     */
    getTargetAndBonusesConfig: (
      storeId: number,
      resourceId: number,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtStoreResourcePerformanceTargetAndBonusesDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/resource/${resourceId}/performance/targetAndBonusesConfig`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreResourcePerformanceConfigApi
     * @name UpdateTargetAndBonusesConfig
     * @summary updateTargetAndBonusesConfig 更新業績目標與獎金設定
     * @request PUT:/api/v3/mgt/store/{storeId}/resource/{resourceId}/performance/targetAndBonusesConfig
     * @secure
     */
    updateTargetAndBonusesConfig: (
      storeId: number,
      resourceId: number,
      data: MgtUpdateStoreResourceTargetAndBonusesReq[],
      params: RequestParams = {}
    ) =>
      this.request<
        MgtStoreResourcePerformanceTargetAndBonusesDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/resource/${resourceId}/performance/targetAndBonusesConfig`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreResourcePerformanceConfigApi
     * @name GetCommissionRateConfig
     * @summary getCommissionRateConfig 查詢業績抽成方式設定
     * @request GET:/api/v3/mgt/store/{storeId}/resource/{resourceId}/performance/commissionRateConfig
     * @secure
     */
    getCommissionRateConfig: (
      storeId: number,
      resourceId: number,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtStoreResourceCommissionRateDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/resource/${resourceId}/performance/commissionRateConfig`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreResourcePerformanceConfigApi
     * @name UpdateCommissionRateConfig
     * @summary updateCommissionRateConfig 更新業績抽成方式設定
     * @request PUT:/api/v3/mgt/store/{storeId}/resource/{resourceId}/performance/commissionRateConfig
     * @secure
     */
    updateCommissionRateConfig: (
      storeId: number,
      resourceId: number,
      data: MgtUpdateStoreResourceCommissionRateReq[],
      params: RequestParams = {}
    ) =>
      this.request<
        MgtStoreResourceCommissionRateDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/resource/${resourceId}/performance/commissionRateConfig`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreApi
     * @name GetUpdateStorePlanInfo
     * @summary getUpdateStorePlanInfo 查詢更新Store使用的方案資訊
     * @request GET:/api/v3/mgt/store/{storeId}/plan/{planId}
     * @secure
     */
    getUpdateStorePlanInfo: (
      storeId: number,
      planId: number,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtUpdateStorePlanInfoDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/plan/${planId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreApi
     * @name UpdateStorePlanWithPayment
     * @summary updateStorePlanWithPayment 更新Store使用的方案
     * @request PUT:/api/v3/mgt/store/{storeId}/plan/{planId}
     * @secure
     */
    updateStorePlanWithPayment: (
      storeId: number,
      planId: number,
      data: MgtUpdateStorePlanWithPaymentReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtUpdateStorePlanDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/plan/${planId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreApi
     * @name GetStoreInvoiceInfo
     * @summary getStoreInvoiceInfo 查詢商家的帳務設定資料
     * @request GET:/api/v3/mgt/store/{storeId}/invoiceInfo
     * @secure
     */
    getStoreInvoiceInfo: (storeId: number, params: RequestParams = {}) =>
      this.request<
        MgtStoreInvoiceDetailDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/invoiceInfo`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreApi
     * @name UpdateStoreInvoiceInfo
     * @summary updateStoreInvoiceInfo 更新商家的帳務設定資料
     * @request PUT:/api/v3/mgt/store/{storeId}/invoiceInfo
     * @secure
     */
    updateStoreInvoiceInfo: (
      storeId: number,
      data: MgtStoreInvoiceDetailReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtStoreInvoiceDetailDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/invoiceInfo`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtGroupUserApi
     * @name GetGroupUserDetail
     * @summary getGroupUserDetail 取得GroupUser詳細資料
     * @request GET:/api/v3/mgt/groupUser/{id}
     * @secure
     */
    getGroupUserDetail: (id: number, params: RequestParams = {}) =>
      this.request<
        MgtGroupUserDetailDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/groupUser/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtGroupUserApi
     * @name UpdateGroupUser
     * @summary updateGroupUser 更新GroupUser
     * @request PUT:/api/v3/mgt/groupUser/{id}
     * @secure
     */
    updateGroupUser: (
      id: number,
      data: MgtUpdateGroupUserReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtGroupUserDetailDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/groupUser/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtGroupUserApi
     * @name DeleteGroupUser
     * @summary deleteGroupUser 刪除GroupUser
     * @request DELETE:/api/v3/mgt/groupUser/{id}
     * @secure
     */
    deleteGroupUser: (id: number, params: RequestParams = {}) =>
      this.request<void, { code: string; name: string; messages: string[] }>({
        path: `/api/v3/mgt/groupUser/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreApi
     * @name SearchStorePaymentHistory
     * @summary searchStorePaymentHistory 取得Store付款紀錄
     * @request POST:/api/v3/mgt/store/{storeId}/searchPaymentHistory
     * @secure
     */
    searchStorePaymentHistory: (
      storeId: number,
      data: MgtSearchStorePaymentHistoryReq,
      params: RequestParams = {}
    ) =>
      this.request<
        PageDtoMgtStorePaymentHistoryDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/searchPaymentHistory`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreApi
     * @name SearchStorePointHistory
     * @summary searchStorePointHistory 查詢Store點數紀錄
     * @request POST:/api/v3/mgt/store/{storeId}/pointHistory/search
     * @secure
     */
    searchStorePointHistory: (
      storeId: number,
      data: PagingAndSortingRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        PageDtoMgtStorePointHistoryDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/pointHistory/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreApi
     * @name BindStorePaymentIntegration
     * @summary bindStorePaymentIntegration 商家金流串接
     * @request POST:/api/v3/mgt/store/{storeId}/paymentIntegrations/{gateway}
     * @secure
     */
    bindStorePaymentIntegration: (
      storeId: number,
      gateway: "INSTO" | "LINE_PAY",
      data: MgtBindStorePaymentIntegrationReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtStorePaymentIntegrationDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/paymentIntegrations/${gateway}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreApi
     * @name RemoveStorePaymentIntegration
     * @summary removeStorePaymentIntegration 商家金流解除串接
     * @request DELETE:/api/v3/mgt/store/{storeId}/paymentIntegrations/{gateway}
     * @secure
     */
    removeStorePaymentIntegration: (
      storeId: number,
      gateway: "INSTO" | "LINE_PAY",
      params: RequestParams = {}
    ) =>
      this.request<void, { code: string; name: string; messages: string[] }>({
        path: `/api/v3/mgt/store/${storeId}/paymentIntegrations/${gateway}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreApi
     * @name DepositStorePoint
     * @summary depositStorePoint 儲值Store點數
     * @request POST:/api/v3/mgt/store/{storeId}/depositPoint
     * @secure
     */
    depositStorePoint: (
      storeId: number,
      data: MgtDepositStorePointReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtStoreDetailDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/depositPoint`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtGroupUserApi
     * @name CreateGroupUser
     * @summary createGroupUser 建立GroupUser
     * @request POST:/api/v3/mgt/groupUser
     * @secure
     */
    createGroupUser: (
      data: MgtCreateGroupUserReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtGroupUserDetailDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/groupUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtGroupUserApi
     * @name SearchGroupUsers
     * @summary searchGroupUsers 取得GroupUser清單
     * @request POST:/api/v3/mgt/groupUser/search
     * @secure
     */
    searchGroupUsers: (params: RequestParams = {}) =>
      this.request<
        MgtSearchGroupUserDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/groupUser/search`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtGroupApi
     * @name SwitchGroup
     * @summary switchGroup 切換Group
     * @request POST:/api/v3/mgt/group/switch
     * @secure
     */
    switchGroup: (data: MgtSwitchGroupReq, params: RequestParams = {}) =>
      this.request<
        MgtSwitchGroupRes,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/group/switch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name SearchStorePeroidDashboardItem
     * @summary searchStorePeroidDashboardItem 查詢區間的Store統計資訊
     * @request POST:/api/v3/mgt/dashboard/storeSummary/{storeId}/peroid
     * @secure
     */
    searchStorePeroidDashboardItem: (
      storeId: number,
      data: MgtSearchDashboardPeroidSummaryReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtDashboardStorePeroidSummaryDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/storeSummary/${storeId}/peroid`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name DownloadStorePeroidSummaryReport
     * @summary downloadStorePeroidSummaryReport 下載區間的Store報表
     * @request POST:/api/v3/mgt/dashboard/storeSummary/{storeId}/peroid/report
     * @secure
     */
    downloadStorePeroidSummaryReport: (
      storeId: number,
      data: MgtDownloadGroupStoreSummaryReportReq,
      params: RequestParams = {}
    ) =>
      this.request<FileDto, { code: string; name: string; messages: string[] }>(
        {
          path: `/api/v3/mgt/dashboard/storeSummary/${storeId}/peroid/report`,
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        }
      ),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name SearchStoreOrderDailyCount
     * @summary searchStoreOrderDailyCount 主控台-分店-預約分析-預約狀態(每日數量)
     * @request POST:/api/v3/mgt/dashboard/storeSummary/{storeId}/dailyOrder
     * @secure
     */
    searchStoreOrderDailyCount: (
      storeId: number,
      data: MgtSearchDashboardPeroidSummaryReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtOrderDailyCountDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/storeSummary/${storeId}/dailyOrder`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name SearchStoreResourceSalaryCommissionRateAnalyze
     * @summary searchStoreResourceSalaryCommissionRateAnalyze 主控台-分店-薪資計算-比例抽成制
     * @request POST:/api/v3/mgt/dashboard/storeSummary/{storeId}/analyze/resource/salary/commissionRate
     * @secure
     */
    searchStoreResourceSalaryCommissionRateAnalyze: (
      storeId: number,
      data: MgtSearchDashboardPeroidSummaryReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtStoreResourceSalaryAnalyzeCommissionDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/storeSummary/${storeId}/analyze/resource/salary/commissionRate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name SearchStoreResourceProductAcquisitionAnalyze
     * @summary searchStoreResourceProductAcquisitionAnalyze 主控台-分店-請領分析
     * @request POST:/api/v3/mgt/dashboard/storeSummary/{storeId}/analyze/resource/productAcquisition
     * @secure
     */
    searchStoreResourceProductAcquisitionAnalyze: (
      storeId: number,
      data: MgtSearchDashboardPeroidSummaryReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtStoreResourceProductAcquisitionAnalyzeDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/storeSummary/${storeId}/analyze/resource/productAcquisition`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name SearchStoreResourcePerformanceAnalyze
     * @summary searchStoreResourcePerformanceAnalyze 主控台-分店-業績分析
     * @request POST:/api/v3/mgt/dashboard/storeSummary/{storeId}/analyze/resource/bill
     * @secure
     */
    searchStoreResourcePerformanceAnalyze: (
      storeId: number,
      data: MgtSearchDashboardPeroidSummaryReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtStoreResourcePerformanceAnalyzeDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/storeSummary/${storeId}/analyze/resource/bill`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name SearchStoreBillAnalyze
     * @summary searchStoreBillAnalyze 主控台-分店-結帳分析
     * @request POST:/api/v3/mgt/dashboard/storeSummary/{storeId}/analyze/bill
     * @secure
     */
    searchStoreBillAnalyze: (
      storeId: number,
      data: MgtSearchDashboardPeroidSummaryReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtStoreBillAnalyzeDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/storeSummary/${storeId}/analyze/bill`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name SearchGroupPeriodDashboardItem
     * @summary searchGroupPeriodDashboardItem 查詢目前登入的區間的Group統計資訊
     * @request POST:/api/v3/mgt/dashboard/groupSummary/peroid
     * @secure
     */
    searchGroupPeriodDashboardItem: (
      data: MgtSearchDashboardPeroidSummaryReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtDashboardGroupPeroidSummaryDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/groupSummary/peroid`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name SearchGroupOrderDailyCount
     * @summary searchGroupOrderDailyCount 主控台-集團-預約分析-預約狀態(每日數量)
     * @request POST:/api/v3/mgt/dashboard/groupSummary/dailyOrder
     * @secure
     */
    searchGroupOrderDailyCount: (
      data: MgtSearchDashboardPeroidSummaryReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtOrderDailyCountDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/groupSummary/dailyOrder`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name SearchGroupOrderCustomerVisitCount
     * @summary searchGroupOrderCustomerVisitCount 主控台-集團-預約分析-比例分析(每日新舊客數)
     * @request POST:/api/v3/mgt/dashboard/groupSummary/dailyOrderCustomerVisitCount
     * @secure
     */
    searchGroupOrderCustomerVisitCount: (
      data: MgtSearchDashboardPeroidSummaryReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtGroupDailyOrderCustomerVisitDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/groupSummary/dailyOrderCustomerVisitCount`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name SearchGroupPeriodOrderCount
     * @summary searchGroupPeriodOrderCount 主控台-集團-預約分析-數據統計
     * @request POST:/api/v3/mgt/dashboard/groupSummary/analyze/orderCount
     * @secure
     */
    searchGroupPeriodOrderCount: (
      data: MgtSearchDashboardPeroidSummaryReq,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtGroupOrderAnalyzeDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/groupSummary/analyze/orderCount`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name DownloadGroupConsumerReport
     * @summary downloadGroupConsumerReport 下載會員報表
     * @request POST:/api/v3/mgt/dashboard/groupConsumerReport/
     * @secure
     */
    downloadGroupConsumerReport: (params: RequestParams = {}) =>
      this.request<FileDto, { code: string; name: string; messages: string[] }>(
        {
          path: `/api/v3/mgt/dashboard/groupConsumerReport/`,
          method: "POST",
          secure: true,
          format: "json",
          ...params,
        }
      ),

    /**
     * No description
     *
     * @tags MgtDepositPointApi
     * @name SearchConsumerGroupDepositHistory
     * @summary searchConsumerGroupDepositHistory 查詢當前Group儲值紀錄
     * @request POST:/api/v3/mgt/consumerGroupDepositHistory/search
     * @secure
     */
    searchConsumerGroupDepositHistory: (
      data: PagingAndSortingRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        PageDtoMgtConsumerGroupDepositHistoryDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/consumerGroupDepositHistory/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtBonusPointApi
     * @name SearchConsumerGroupBonusHistory
     * @summary searchConsumerGroupBonusHistory 查詢當前Group補扣紅利點紀錄
     * @request POST:/api/v3/mgt/consumerGroupBonusHistory/search
     * @secure
     */
    searchConsumerGroupBonusHistory: (
      data: PagingAndSortingRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        PageDtoMgtConsumerGroupBonusHistoryDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/consumerGroupBonusHistory/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreApi
     * @name GetStores
     * @summary getStores 取得Store清單
     * @request GET:/api/v3/mgt/store
     * @secure
     */
    getStores: (
      query?: { withBoundPaymentGatewayCnt?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<
        MgtStoreDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreApi
     * @name GetStoreDetail
     * @summary getStoreDetail 取得Store詳細內容
     * @request GET:/api/v3/mgt/store/{storeId}
     * @secure
     */
    getStoreDetail: (storeId: number, params: RequestParams = {}) =>
      this.request<
        MgtStoreDetailDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreApi
     * @name GetStorePaymentIntegrations
     * @summary getStorePaymentIntegrations 取得商家金流串接清單
     * @request GET:/api/v3/mgt/store/{storeId}/paymentIntegrations
     * @secure
     */
    getStorePaymentIntegrations: (
      storeId: number,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtStorePaymentIntegrationDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/paymentIntegrations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreApi
     * @name GetNextEstimatedCharge
     * @summary getNextEstimatedCharge 取得Store下期預估扣款金額明細
     * @request GET:/api/v3/mgt/store/{storeId}/nextEstimatedCharge
     * @secure
     */
    getNextEstimatedCharge: (storeId: number, params: RequestParams = {}) =>
      this.request<
        MgtNextEstimatedChargeInfoDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/nextEstimatedCharge`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtStoreApi
     * @name GetStoreInvitationInfo
     * @summary getStoreInvitationInfo 取得Store邀請內容
     * @request GET:/api/v3/mgt/store/{storeId}/intivationInfo
     * @secure
     */
    getStoreInvitationInfo: (storeId: number, params: RequestParams = {}) =>
      this.request<
        MgtStoreInvitationInfoDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/store/${storeId}/intivationInfo`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtPlanApi
     * @name GetPlanDetail
     * @summary getPlanDetail
     * @request GET:/api/v3/mgt/plan/{planId}
     * @secure
     */
    getPlanDetail: (planId: number, params: RequestParams = {}) =>
      this.request<
        MgtPlanDetailDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/plan/${planId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtGroupUserApi
     * @name GetCurrentGroupUser
     * @summary getCurrentGroupUser 取得目前登入的GroupUser
     * @request GET:/api/v3/mgt/me
     * @secure
     */
    getCurrentGroupUser: (params: RequestParams = {}) =>
      this.request<
        MgtGroupUserDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtGroupApi
     * @name GetGroups
     * @summary getGroups 取得Group清單
     * @request GET:/api/v3/mgt/group
     * @secure
     */
    getGroups: (params: RequestParams = {}) =>
      this.request<
        MgtGroupDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/group`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name GetStoreSummary
     * @summary getStoreSummary 取得Store統計資訊
     * @request GET:/api/v3/mgt/dashboard/storeSummary/{storeId}
     * @secure
     */
    getStoreSummary: (storeId: number, params: RequestParams = {}) =>
      this.request<
        MgtDashboardSummaryDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/storeSummary/${storeId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name GetStoreResourceOrderAnalyze
     * @summary getStoreResourceOrderAnalyze 主控台-分店-預約分析-指定分析/熟客分析(by resource)
     * @request GET:/api/v3/mgt/dashboard/storeSummary/{storeId}/analyze/resourceOrderAnalyze
     * @secure
     */
    getStoreResourceOrderAnalyze: (
      storeId: number,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtStoreResourceOrderAnalyzeFromLastMonthDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/storeSummary/${storeId}/analyze/resourceOrderAnalyze`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name GetStoreConsumerBackgroundAnalyze
     * @summary getStoreConsumerBackgroundAnalyze 主控台-分店-預約分析-背景分析
     * @request GET:/api/v3/mgt/dashboard/storeSummary/{storeId}/analyze/consumerBackground
     * @secure
     */
    getStoreConsumerBackgroundAnalyze: (
      storeId: number,
      params: RequestParams = {}
    ) =>
      this.request<
        MgtConsumerBackgroundAnalyzeDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/storeSummary/${storeId}/analyze/consumerBackground`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name GetCurrentGroupSummary
     * @summary getCurrentGroupSummary 取得目前登入的Group統計資訊
     * @request GET:/api/v3/mgt/dashboard/groupSummary
     * @secure
     */
    getCurrentGroupSummary: (params: RequestParams = {}) =>
      this.request<
        MgtDashboardSummaryDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/groupSummary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name GetGroupVoucherAnalyze
     * @summary getGroupVoucherAnalyze 主控台-集團-票券分析
     * @request GET:/api/v3/mgt/dashboard/groupSummary/analyze/voucher
     * @secure
     */
    getGroupVoucherAnalyze: (params: RequestParams = {}) =>
      this.request<
        MgtGroupVoucherAnalyzeDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/groupSummary/analyze/voucher`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name GetGroupDepositPointAnalyze
     * @summary getGroupDepositPointAnalyze 主控台-集團-儲值金分析
     * @request GET:/api/v3/mgt/dashboard/groupSummary/analyze/depositPoint
     * @secure
     */
    getGroupDepositPointAnalyze: (params: RequestParams = {}) =>
      this.request<
        MgtGroupDepositPointAnalyzeDto,
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/groupSummary/analyze/depositPoint`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name GetGroupConsumerAnalyze
     * @summary getGroupConsumerAnalyze 主控台-集團-會員分析
     * @request GET:/api/v3/mgt/dashboard/groupSummary/analyze/consumer
     * @secure
     */
    getGroupConsumerAnalyze: (params: RequestParams = {}) =>
      this.request<
        MgtConsumerBackgroundAnalyzeDto[],
        { code: string; name: string; messages: string[] }
      >({
        path: `/api/v3/mgt/dashboard/groupSummary/analyze/consumer`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MgtDashboardApi
     * @name DownloadGroupConsumerVoucherReport
     * @summary downloadGroupConsumerVoucherReport 主控台-全品牌-報表下載-票卷報表下載
     * @request GET:/api/v3/mgt/dashboard/groupConsumerVoucherReport/
     * @secure
     */
    downloadGroupConsumerVoucherReport: (params: RequestParams = {}) =>
      this.request<FileDto, { code: string; name: string; messages: string[] }>(
        {
          path: `/api/v3/mgt/dashboard/groupConsumerVoucherReport/`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }
      ),
  };
}
